export const CONTACT_REGISTER_REQUEST = "CONTACT_REGISTER_REQUEST";
export const CONTACT_REGISTER_SUCCESS = "CONTACT_REGISTER_SUCCESS";
export const CONTACT_REGISTER_FAIL = "CONTACT_REGISTER_FAIL";
export const CONTACT_REGISTER_RESET = "CONTACT_REGISTER_RESET";
